export default {
    namespaced: true,
}
